module.exports = __webpack_public_path__ + "img/cart-check.6efd118e.svg";